export enum SurveyPhotoTypeEnum {
  Facade,
  Detail,
  FrontYard,
  OutsideIntro,
  General,
  Underground,
  GeneralTechnicalInfoPhoto,
  OutsideCopperIntro,
  InsideCopperIntro,
  OutsideFibreIntro,
  InsideFibreIntro,
  TelcoRoom,
  ProximusEquipment,
  FloorPlan,
  ElectricityInTelcoRoom,
  RoomAvailableForNewEquipment,
  SolutionDoubt,
}
